/* 
 * MapMutationContent.js
 * Created on 24-mrt-2017
 * @author Swen Meeuwes for &ranj
 */

import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";
import NodeMutationBooleanContent from "./NodeMutationBooleanContent";

export default class MapMutationContent extends Content {
    constructor(languagePack, contentID, label) {
        super(MapMutationContent.NAME, MapMutationContent.TYPE, label, languagePack, contentID);

        this._localLanguagePack = languagePack;
        this._localContentID = contentID;
        this._localLabel = label;
    }

    remove() {
        this.removeLanguagePackText(MapMutationContent.NODE_ID_LABEL);

        super.remove();
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_MAP_MUTATION, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setNodeID(this.getNodeID());

        for (let i = 0; i <= this.getMutations().length; i++) {
            clone.getMutations().push(this.getMutations()[i].clone());
        }

        return clone;
    }

    getValueForProperty(property) {
        return this.getLanguagePackText(property);
    }

    setValueForProperty(property, value) {
        if (this.getValueForProperty(property) !== value) {
            this.setLanguagePackText(property, value);
        }
    }

    getNodeID() {
        return this.getValueForProperty(MapMutationContent.NODE_ID_LABEL);
    }

    setNodeID(value) {
        this.setValueForProperty(MapMutationContent.NODE_ID_LABEL, value);
    }

    getMutations() {
        const mutations = [];
        for (let i = 0; i < this._mutations.length; i++) {
            const mutation = new NodeMutationBooleanContent(this._localLanguagePack, this._localContentID, this._localLabel);
            mutation.mutationType = this._mutations[i].mutationType;
            mutation.value = this._mutations[i].value;

            mutations.push(mutation);
        }

        return mutations;
    }

    setMutations(mutations) {
        this._mutations = mutations;
    }

    convertToObject() {
        const object = super.convertToObject();

        // TODO ?? COPIED FROM KEYMOMENTCHOICE
        //object["choice"] = this._choice;
        //object["image"] = this._image;
        //object["tip"] = this._tip;
        //object["situationDescription"] = this._situationDescription;
        return object;
    }

    setPropertiesFromObject(object) {
        super.setPropertiesFromObject(object);
    }

    getDescriptionLabel() {
        let label;
        label = this.getNodeID().toString();
        if (!label || label === "") {
            label = "Map Mutation: <NO NODE>";
        }
        else {
            label = `Map Mutation: ${label}`;
        }
        return label;
    }
}


MapMutationContent.TYPE = ContentTypes.TYPE_MAP_MUTATION;
MapMutationContent.NAME = "Map Mutation";
MapMutationContent.NODE_ID_LABEL = "nodeID";
